/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToFromData
 */
export interface ToFromData {
    /**
     * 
     * @type {string}
     * @memberof ToFromData
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof ToFromData
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof ToFromData
     */
    fixed?: string;
}

/**
 * Check if a given object implements the ToFromData interface.
 */
export function instanceOfToFromData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ToFromDataFromJSON(json: any): ToFromData {
    return ToFromDataFromJSONTyped(json, false);
}

export function ToFromDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToFromData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to': !exists(json, 'to') ? undefined : json['to'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'fixed': !exists(json, 'fixed') ? undefined : json['fixed'],
    };
}

export function ToFromDataToJSON(value?: ToFromData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to': value.to,
        'from': value.from,
        'fixed': value.fixed,
    };
}

